import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const balintSessionsClient = axios.create({
  baseURL: process.env.VUE_APP_PSYCHOLOGY_CONSULTATION_URL,
  withCredentials: true,
});

balintSessionsClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(balintSessionsClient);

export default balintSessionsClient;